import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  Ch_generateNeuropsychologicDiagnosticPrescriptionInput,
  useChGenerateNeuropsychologicDiagnosticPrescriptionMutation as useChGenerateNeuropsychologicDiagnosticPrescriptionMutationType,
} from "@/modules/patients/detail/neuropsychologic-diagnostic-prescription/ch/services/__generated__/useChGenerateNeuropsychologicDiagnosticPrescriptionMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const mutation = graphql`
  mutation useChGenerateNeuropsychologicDiagnosticPrescriptionMutation(
    $input: Ch_generateNeuropsychologicDiagnosticPrescriptionInput!
  ) {
    ch_generateNeuropsychologicDiagnosticPrescription(input: $input) {
      ch_NeuropsychologicDiagnosticPrescription {
        id
        fileId
        ...chNeuropsychologicDiagnosticPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChGenerateNeuropsychologicDiagnosticPrescriptionMutationType>, "variables"> & {
  id: Ch_generateNeuropsychologicDiagnosticPrescriptionInput["id"]
}

const useChGenerateNeuropsychologicDiagnosticPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] =
    useMutationWithErrorDialog<useChGenerateNeuropsychologicDiagnosticPrescriptionMutationType>(mutation, params)
  const patientById = usePatientParam()

  const commitHandler = useCallback(
    (config: Config) => {
      const { id } = config

      commit({
        variables: {
          input: { id, patientId: patientById },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useChGenerateNeuropsychologicDiagnosticPrescriptionMutation }
